module.exports = __webpack_public_path__ + "img/wr.e9b00e0b.svg";